module.exports = __webpack_public_path__ + "img/5.598d843b.jpg";